/**
 * <TutorTeamSectionSkeleton> — la forme de « Mon tuteur » pendant le chargement.
 *
 * Le cas courant : un tuteur, donc son intitulé, « Mon tuteur », puis sa ligne.
 */
import React from "react"

import { Stack } from "../../atoms/containers/Stack"
import { SectionLabel } from "../../atoms/typography/SectionLabel"
import { CardList } from "../../molecules/CardList"
import { TutorRowSkeleton } from "../../molecules/TutorRow"
import { tutorTeamTitle } from "./TutorTeamSection"

export function TutorTeamSectionSkeleton() {
    return (
        <Stack gap="3">
            <SectionLabel>{tutorTeamTitle(1)}</SectionLabel>
            <CardList>
                <TutorRowSkeleton />
            </CardList>
        </Stack>
    )
}
